import { MenuItem } from 'prosemirror-menu';
import { Node, NodeType, Schema } from 'prosemirror-model';
import { EditorState, NodeSelection } from 'prosemirror-state';
import { Observable, Subscription } from 'rxjs';

import { ImagePlaceholderPlugin } from '../plugins/image-placeholder.plugin';

const findImage = (state: EditorState, nodeType: NodeType) => {
  let imgNode: Node;

  state.selection.content().content.forEach(node => {
    if (node.type === nodeType) {
      imgNode = node;
    }
  });

  return imgNode;
};

export interface ImageUploader {
  upload: Observable<Observable<string>>;
  select();
}

export function inserImageItem(nodeType: NodeType, uploader: ImageUploader) {
  let sub: Subscription;
  return new MenuItem({
    title: 'Image',
    label: ' ',
    class: 'ProseMirror-icon-image',
    css: undefined,

    enable(state) {
      return !findImage(state, nodeType);
    },

    run(_, __, view) {
      uploader.select();
      if (!sub) {
        sub = uploader.upload.subscribe(url$ => {
          const ref = ImagePlaceholderPlugin.add(view);
          url$.subscribe(
            url => ref.replace(nodeType.create({ src: url })),
            () => ref.clear(),
          );
        });
      }
    },
  });
}

export function imagePositionItem(
  nodeType: NodeType,
  position: 'block' | 'float-left' | 'float-right',
  options,
) {
  const run = (state: EditorState, dispatch?) => {
    const img = findImage(state, nodeType);
    if (!img || img.attrs.position === position) {
      return false;
    }

    if (dispatch) {
      const copy = nodeType.create({
        position,
        src: img.attrs.src,
      });

      let tr = state.tr.replaceSelectionWith(copy);
      img.marks.forEach(mark => {
        tr = tr.addMark(state.selection.from, state.selection.to, mark);
      });
      tr.setSelection(NodeSelection.create(tr.doc, state.selection.from));
      dispatch(tr);
      return false;
    } else {
      return true;
    }
  };

  return new MenuItem({
    ...options,
    label: ' ',
    enable: state => run(state),
    run,
  });
}

export interface ImageMenuOptions {
  uploader: ImageUploader;
}

export function imageMenu(schema: Schema, options: ImageMenuOptions) {
  return [
    inserImageItem(schema.nodes.image, options.uploader),
    imagePositionItem(schema.nodes.image, 'block', {
      title: 'Block',
      class: 'ProseMirror-icon-img-block',
    }),
    imagePositionItem(schema.nodes.image, 'float-left', {
      title: 'Float left',
      class: 'ProseMirror-icon-img-float-left',
    }),
    imagePositionItem(schema.nodes.image, 'float-right', {
      title: 'Float right',
      class: 'ProseMirror-icon-img-float-right',
    }),
  ];
}
